import { registerCoreArtifactTypes } from './core';

/** Side-effect registration of core artifact types. */
registerCoreArtifactTypes();
